import { useState } from "react";
import styles from "./styles.module.css";
import Campo from "../../../components/Campo";
import CampoTextoLongo from "../../../components/Campo/CampoTextoLongo";
import CampoSelect from "../../../components/Campo/CampoSelect";
import { Modalidade } from "../../../enums/Modalidade";
import { DescricaoDoProjeto } from "../../../model/PlanoDeTrabalho/DescricaoDoProjeto";
import CampoDate from "../../../components/Campo/CampoDate";
import VerificaForm from "../../../controllers/VerificaForm";
import { toIsoString } from "../../../controllers/Converters";
import { PlanoDeTrabalho } from "../../../model/PlanoDeTrabalho";

type Props = {
  passarPagina: Function;
  descricaoObj: PlanoDeTrabalho;
};

function Descricao({ passarPagina, descricaoObj }: Props) {
  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          1. Descrição do <strong>Projeto</strong>
        </h2>
      </div>
      <div className={styles.gridCampos}>
        <Campo
          title="Titulo do Projeto/Atividade"
          type="text"
          placeholder="Digite o Titulo do seu Projeto ou Atividade"
          maxLength={64}
          customValidity="Preencha com o Titulo do seu Projeto"
          value={descricaoObj.titulo_projeto}
        />
        <div
          className={
            descricaoObj.modalidade === Modalidade.colaboracao
              ? styles.gridCampos
              : ""
          }
        >
          <Campo
            title="Modalidade"
            type="text"
            value={descricaoObj.modalidade}
          />

          {descricaoObj.modalidade === Modalidade.colaboracao && (
            <Campo
              title="Numero do Edital"
              type="number"
              placeholder="Digite o numero do edital"
              required={descricaoObj.modalidade === Modalidade.colaboracao}
              customValidity="Preencha com o Órgão/Entidade Financiador"
              value={descricaoObj.edital_id}
            />
          )}
        </div>
        <Campo
          title="Órgão/Entidade Financiador"
          type="text"
          maxLength={64}
          value={descricaoObj.orgao_financiador}
        />
        <Campo
          title="Objeto da Parceria"
          type="text"
          maxLength={64}
          value={descricaoObj.objeto_parceria}
        />
        <Campo
          title="Área de Atendimento"
          type="text"
          maxLength={64}
          value={descricaoObj.area_atendimento}
        />

        <div className={styles.gridCampos}>
          <CampoDate title="Inicio" value={descricaoObj.inicio} />
          <CampoDate title="Fim" value={descricaoObj.fim} />
        </div>
      </div>
      <CampoTextoLongo
        title="Descrição da realidade"
        value={descricaoObj.descricao_realidade}
        hideAsterisk
      />
      <CampoTextoLongo
        title="Forma de Execução das Ações"
        value={descricaoObj.forma_execucao}
        hideAsterisk
      />
      <CampoTextoLongo
        title="Descrição de Metas Quantitativas"
        value={descricaoObj.descricao_metas}
        hideAsterisk
      />
      <CampoTextoLongo
        title="Definição dos Indicadores"
        value={descricaoObj.indicadores}
        hideAsterisk
      />

      <div className="flex justify-end">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proxima Página ❯❯
        </button>
      </div>
    </form>
  );
}

export default Descricao;
